import { supabase } from '../../../lib/supabaseClient';

export async function shareASPWithLawyer(aspId, lawyerEmail, lawyerName = null, lawFirm = null) {
  const { data, error } = await supabase
    .rpc('share_asp_with_lawyer', {
      p_asp_id: aspId,
      p_lawyer_email: lawyerEmail,
      p_lawyer_name: lawyerName,
      p_law_firm: lawFirm
    });

  if (error) throw error;
  return data;
}

export async function getASPShares(aspId) {
  const { data, error } = await supabase
    .from('asp_lawyer_shares')
    .select('*')
    .eq('asp_id', aspId)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data || [];
}

export async function revokeShare(shareId) {
  const { data: { user } } = await supabase.auth.getUser();

  const { data, error } = await supabase
    .from('asp_lawyer_shares')
    .update({
      revoked_at: new Date().toISOString(),
      revoked_by: user.id
    })
    .eq('id', shareId)
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function getASPByShareToken(shareToken) {
  const { data, error } = await supabase
    .rpc('get_asp_by_share_token', {
      p_share_token: shareToken
    });

  if (error) throw error;
  return data;
}
